export default __webpack_public_path__ + "media/Block.58592293.svg";